module.exports = __webpack_public_path__ + "img/swiper5.2aebebd1.png";